import type { OptionChoices } from "building-types/options/optionChoices";
import type { EvaluatedRoof, Roof, RoofSystem } from "building-types/roofs/roofSystemTypes";
import type { Table } from "common/data/table";
import { evalFormulas } from "doc/formula/evalFormulas";

/**
 * Evaluates roof and roof-system formulas, returning evaluated tables without
 * any component instance augmentation.
 */
export function evaluateRoofSystems({
  initialRoofSystems,
  initialRoofs,
  optionChoices,
  entityDisabledByGroup,
}: {
  initialRoofSystems: Table<RoofSystem>;
  initialRoofs: Table<Roof>;
  optionChoices: OptionChoices;
  entityDisabledByGroup: Table<boolean>;
}): { roofSystems: Table<RoofSystem>; roofs: Table<EvaluatedRoof> } {
  const roofSystems = evalFormulas(
    initialRoofSystems,
    (v) => optionChoices[v],
    undefined,
    entityDisabledByGroup,
  ) as Table<RoofSystem>;
  const roofs = evalFormulas(
    initialRoofs,
    (v) => optionChoices[v],
    undefined,
    entityDisabledByGroup,
  ) as Table<EvaluatedRoof>;

  return { roofSystems, roofs };
}
